var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: {
      label: _vm.name,
      "min-width": _vm.columnWidth,
      fixed: false,
      align: "center",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-check", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkEdit(
                    scope.$index,
                    _vm.code,
                    scope.row[_vm.code],
                    scope.row
                  ),
                  expression:
                    "checkEdit(scope.$index, code, scope.row[code], scope.row)",
                },
              ],
              ref: "input_" + scope.$index + "_" + _vm.code,
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                "key-field": _vm.keyField,
                "value-field": _vm.valueField,
                options: _vm.options,
                require: _vm.getRequire,
              },
              on: { onFieldChange: _vm.onFieldChange },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
            _c("ik-table-check-tag", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.checkEdit(
                    scope.$index,
                    _vm.code,
                    scope.row[_vm.code],
                    scope.row
                  ),
                  expression:
                    "!checkEdit(scope.$index, code, scope.row[code], scope.row)",
                },
              ],
              attrs: {
                "default-value": _vm.defaultValue,
                value: scope.row[_vm.code],
                "key-field": _vm.keyField,
                "value-field": _vm.valueField,
                options: _vm.options,
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }